@if (label) {
  <p-floatLabel>
    <ng-container *ngTemplateOutlet="calendar"></ng-container>
    <label [for]="inputId">{{ label }}</label>
  </p-floatLabel>
} @else {
  <ng-container *ngTemplateOutlet="calendar"></ng-container>
}

<ng-template #calendar>
  <div class="p-inputgroup crm-daterangepicker-inputgroup">
    <span class="p-inputgroup-addon"><i class="pi pi-calendar"></i></span>
    <p-calendar
      #rangepicker
      (ngModelChange)="changeDate($event)"
      (onShow)="show.emit($event)"
      (onClose)="close.emit($event)"
      [(ngModel)]="_value"
      [dateFormat]="dateFormat"
      [firstDayOfWeek]="1"
      [inputId]="inputId"
      [placeholder]="placeholder"
      [selectOtherMonths]="true"
      [showButtonBar]="showButtonBar"
      [showClear]="showClear"
      [appendTo]="appendTo || (filtersUiVersion === 'v2' ? 'body' : '')"
      [panelStyleClass]="datepickerPanelClass"
      selectionMode="range"
      [styleClass]="filtersUiVersion === 'v2' ? 'crm-daterangepicker-calendar-v2' : 'w-full'">
      <ng-template pTemplate="header">
        <div class="flex flex-wrap">
          <div class="w-6 p-1">
            @if (isShowDay) {
              <crm-button
                (onClick)="setPeriodDates('day')"
                styleClass="p-button-sm p-button-success p-button-outlined w-full text-base"
                label="сегодня"></crm-button>
            }
          </div>
          <div class="w-6 p-1">
            @if (isShowDay) {
              <crm-button
                (onClick)="setPeriodDates('day', true)"
                styleClass="p-button-sm p-button-success p-button-outlined w-full text-base"
                label="вчера"></crm-button>
            }
          </div>
          <div class="w-6 p-1">
            <crm-button
              (onClick)="setPeriodDates('week')"
              styleClass="p-button-sm p-button-success p-button-outlined w-full text-base"
              label="текущая неделя"></crm-button>
          </div>
          <div class="w-6 p-1">
            <crm-button
              (onClick)="setPeriodDates('month')"
              styleClass="p-button-sm p-button-success p-button-outlined w-full text-base"
              label="текущий месяц"></crm-button>
          </div>
          <div class="w-6 p-1">
            <crm-button
              (onClick)="setPeriodDates('month', true)"
              styleClass="p-button-sm p-button-success p-button-outlined w-full text-base"
              label="прошлый месяц"></crm-button>
          </div>
          <div class="w-6 p-1">
            <crm-button
              (onClick)="setPeriodDates('year')"
              styleClass="p-button-sm p-button-success p-button-outlined w-full text-base"
              label="текущий год"></crm-button>
          </div>
        </div>
      </ng-template>
    </p-calendar>
  </div>
</ng-template>
